/*
	import { listPhysicalMeetings } from '@/services/BoardMeetings/PhysicalMeeting/List';

  const { physicalMeetings } = await listPhysicalMeetings ({
    params: {
			hoaID
    }
  });
*/

import _get from 'lodash/get'
import kms from '@/services/kms'
import { notifyError } from '@/services/notify'

export async function listPhysicalMeetings({ params }) {
  let message = 'The physical meetings list could not be retrieved.'

  try {
    const result = await kms.get(`/BoardMeetings/PhysicalMeeting/List`, {
      params: {
        hoaID: params.hoaID
      }
    })

    let list = _get(result, 'results', [])
    if (!Array.isArray(list)) {
      list = []
    }

    return {
      successful: true,
      message: '',
      physicalMeetings: list
    }
  } catch (exception) {
    console.error(exception)
  }

  notifyError(message)

  return {
    successful: false,
    message,
    physicalMeetings: []
  }
}
